var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"with-bg stats app-container"},[_c('div',{staticClass:"page-title"},[_c('h2',[_vm._v(_vm._s(_vm.$t('general.users')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }